import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment.development";
import {CatalogoInterface} from "../../users/interfaces/proyecto.interface";
import {CacheService} from "./cache-service";
import {InstitucionItem} from "../../users/tramites/components/interfaces/tramites.interface";

const apiVucUrl = environment.apiVucUrl

@Injectable({providedIn: 'root'})
export class CatalogoService {
    constructor(private http: HttpClient, private cacheService: CacheService) {
    }

    getCatalogo(catalogo: string) {
        let url = apiVucUrl + `api/v1.0/catalogos/${catalogo}`;
        return this.cacheService.memoize(url, this.http.get<CatalogoInterface[]>(url))
    }

    getCatalogoFromCache(catalogo: string) {
        let url = apiVucUrl + `api/v1.0/catalogos/${catalogo}`;
        return this.cacheService.memoize(url, this.http.get<CatalogoInterface[]>(url))
    }

    getUrbanizacion(catalogo: string, idLocalizacion: string, idDensidad: string) {
        return this.http.get<CatalogoInterface[]>(apiVucUrl + `api/v1.0/catalogos/${catalogo}/${idLocalizacion}/${idDensidad}`)
    }

    getInstituciones(permiteSeleccion?: boolean | null) {
        console.log(`getInstituciones(${permiteSeleccion})`)
        if (permiteSeleccion === undefined) {
            permiteSeleccion = null;
        }
        let url = apiVucUrl + `api/v1.0/instituciones?ps=${permiteSeleccion}`;
        return this.cacheService.memoize(url, this.http.get<InstitucionItem[]>(url))
    }
}
